<script setup lang="ts">
  import { Alert, AlertDescription, AlertTitle } from '@ui/components/alert';
  import { HoverCard, HoverCardContent, HoverCardTrigger } from '@ui/components/hover-card';
</script>

<template>
  <HoverCard :open-delay="200">
    <HoverCardTrigger as-child>
      <span class="inline-flex cursor-default text-muted-foreground hover:opacity-80" @click.stop>
        <i class="far fa-exclamation-circle text-xs" />
      </span>
    </HoverCardTrigger>

    <HoverCardContent class="w-80 border-0 bg-background p-0 shadow-none">
      <Alert variant="secondary" size="xs" class="shadow-md">
        <div class="flex items-center w-full justify-between">
          <div class="flex flex-col gap-y-1">
            <AlertTitle class="text-agent space-x-1"
              ><span>Meet dynamic signatures</span> <i class="far fa-sparkles"
            /></AlertTitle>

            <AlertDescription
              >View and edit your signature here, we'll automatically add it on every send.<br /><em
                >New drafts are generated without a sign-off — any signature already in an older
                draft can be safely removed.</em
              >
            </AlertDescription>
          </div>
        </div>
      </Alert>
    </HoverCardContent>
  </HoverCard>
</template>
